module.exports = __webpack_public_path__ + "assets/img/logo.1bd6c945.png";